<template>
  <div class="login-view">
    <img class="site-logo" src="@/assets/unsung-logo-color.png" />
    <h3>Developer Login</h3>
    <div :class="loginSuccess === false ? 'error' : ''">
      <input
        id="email-input"
        v-model="input.username"
        placeholder="Email"
        type="email"
      />
      <br />
      <div class="password-container">
        <input
          id="password-input"
          v-model="input.password"
          placeholder="Password"
          type="password"
        />
      </div>
      <p v-if="loginSuccess === false">Invalid Email or Access Code</p>
    </div>
    <div>
      <br />
      <button type="button" @click="login">Login</button>
    </div>
    <p>Interested in getting Unsung for your classroom? <a href="https://www.verizon.com/learning" target="_blank">Learn more</a>.</p>
  </div>
</template>

<script>
export default {
  name: "DevLogin",
  data() {
    return {
      input: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    loginSuccess: function () {
      return this.$store.state.loginSuccess;
    },
  },
  methods: {
    login: function () {
      this.$store.commit("SEND_MESSAGE", {
        data: { email: this.input.username, password: this.input.password },
        opCode: this.$store.state.opCodes.TeacherClientLogin,
      });
      this.$store.commit("SET_USER_TYPE", 'Dev');
    },
    disconnect: function () {
      this.conn.disconnect();
    },
  },
};
</script>

<style lang="scss">
/* ../assets/scss/_login.scss */
</style>